import { Button, Grid } from "@mui/material";
import { PlusLg } from "react-bootstrap-icons";
import { useSelector } from "react-redux";
import { BucketNodeItem, CurrentUser, FamilyBucketLabel } from "../../types";

interface BucketNodeProps {
	Node: BucketNodeItem,
	Depth: number,
	ChildrenByParent: { [key: number]: number[] },
	NodeById: { [key: number]: BucketNodeItem },
	UsageLabelFor: (bucketNodeId: number) => string,
	OnEdit: (node: BucketNodeItem) => void,
	OnAddChild: (parentNodeId: number, childTypeKey: string) => void
}

const BucketNode = (props: BucketNodeProps) => {
	const user: CurrentUser = useSelector((state: any) => state.userData.value);
	const childTypes = (user.bucketDefinitions?.definitions ?? [])
		.filter(d => d.isEnabled && d.parentBucketTypeKey?.toLowerCase() === props.Node.bucketTypeKey.toLowerCase())
		.sort((a, b) => a.sortOrder - b.sortOrder)
		.map(d => d.bucketTypeKey);
	const children = (props.ChildrenByParent[props.Node.bucketNodeId] ?? [])
		.map(id => props.NodeById[id])
		.filter(Boolean)
		.sort((a, b) => a.displayName.localeCompare(b.displayName));
	const usageLabel = props.UsageLabelFor(props.Node.bucketNodeId);

	return (
		<Grid item xs={12} sx={{ pl: props.Depth * 3 }}>
			<Grid container className="py-2 text-app cursor-pointer" style={{ textAlign: 'left' }} onClick={() => props.OnEdit(props.Node)}>
				<Grid item xs={12} xl={8}>
					<h4>{props.Node.displayName}</h4>
					{usageLabel && <small className="text-muted">{usageLabel}</small>}
				</Grid>
				<Grid item xs={12} xl={4} style={{ textAlign: 'right' }}>
					{childTypes.map(typeKey => (
						<Button
							key={`${props.Node.bucketNodeId}-${typeKey}`}
							size="small"
							variant="text"
							onClick={(e) => {
								e.stopPropagation();
								props.OnAddChild(props.Node.bucketNodeId, typeKey);
							}}>
							<PlusLg className="me-1" /> {FamilyBucketLabel(user, typeKey, typeKey)}
						</Button>
					))}
				</Grid>
			</Grid>
			{children.map(child => (
				<BucketNode
					key={child.bucketNodeId}
					Node={child}
					Depth={props.Depth + 1}
					ChildrenByParent={props.ChildrenByParent}
					NodeById={props.NodeById}
					UsageLabelFor={props.UsageLabelFor}
					OnEdit={props.OnEdit}
					OnAddChild={props.OnAddChild} />
			))}
		</Grid>
	);
};

export default BucketNode;
